export const HistoryActions = new Map<string, string>([
  ["create", "Создание"],
  ["edit", "Редактирование"],
  ["move", "Перемещение"],
  ["delete", "Удаление"],
  ["restore", "Востановление"],
  ["changePassword", "Смена пароля"],
  ["invite", 'Приглашение'],
  ["archive", 'Архивация'],
  ["unarchive", 'Разархивация']
]);

//Для фильтра на странице проекта
export const ProjectHistoryActions = new Map<string, string>([
  ["create", "Создание"],
  ["edit", "Редактирование"],
  ["move", "Перемещение"],
  ["delete", "Удаление"],
  ["restore", "Востановление"],
  ["archive", 'Архивация'],
  ["unarchive", 'Разархивация']
]);